import React, { useCallback, useEffect, useMemo, useState } from "react";
import "../../../src/style.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Box,
  Chip,
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  FormControl,
  RadioGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
  InputAdornment,
  CircularProgress,
  Radio,
  FormControlLabel,
  Checkbox,
  DialogContentText,
  ListItemText,
} from "@mui/material";
import {
  DataGrid,
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { ThemeProvider } from "@mui/styles";
import Close from "@mui/icons-material/Close";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import Backdrop from "@mui/material/Backdrop";
import { getDid } from "../../redux/actions/destinationAction";
import { getAllUsers } from "../../redux/actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import {
  getRedirectDestination,
  getUserRedirectGroups,
  updateRedirectDestination,
  updateRedirectDestinationStaus,
} from "../../redux/actions/redirectPortal/redirectPortal_destinationAction";
import { IconBase } from "react-icons/lib";
import { StyledDataGrid } from "../../pages/CustomDataGrid";
import PageTitle from "../../components/common/PageTitle";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { hasUserFeature } from "./utils/userFeatures";
import { GET_REDIRECT_DESTINATION_SUCCESS } from "../../redux/constants/redirectPortal/redirectportal_destinationConstants";
import dayjs from "dayjs";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const theme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-row": {
            minHeight: "auto",
          },
        },
      },
      defaultProps: {
        density: "compact",
      },
    },
  },
});

function CustomToolbar() {
  return (
    <GridToolbarContainer
      sx={{
        "& .MuiButton-root": {
          fontSize: {
            xs: "12px", // mobile
            sm: "14px", // tablet
            md: "14px", // desktop
          },
          minWidth: "auto",
        },
        "& .MuiSvgIcon-root": {
          fontSize: {
            xs: "16px",
            sm: "18px",
          },
        },
      }}
    >
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <GridToolbarFilterButton />
    </GridToolbarContainer>
  );
}

const options = ["VOIP", "FAKE"];

function Destination({ userThem }) {
  // Gated by the per-user 'voip_spam' feature (admin-managed via User Mgmt).
  // When false, the VOIP Spam dropdown is hidden and the field is omitted
  // from the update payload — backend also enforces this independently.
  const voipSpamEnabled = hasUserFeature("voip_spam");
  const [edit, setEdit] = useState(false);
  const [destination, setDestination] = useState("");
  const [destinationId, setDestinationId] = useState("");
  const [recording, setRecording] = useState(false);
  const [description, setDescription] = useState("");
  const [ivrAuthentication, setIvrAuthentication] = useState("");
  const [redirectGroup, setRedirectGroup] = useState("");
  const [redirectGroupData, setRedirectGroupData] = useState([]);
  const [status, setStatus] = useState("");
  const [voip, setVoip] = useState([]);
  const [response, setResponse] = useState("");
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [radioValue, setRadioValue] = useState("");
  const [selectedDescription, setSelectedDescription] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [showBulkActions, setShowBulkActions] = useState(false);
  const state = useSelector((state) => state);
  const [searchDestination, setSearchDestination] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [name, setName] = useState("");
  const dispatch = useDispatch();

  const handleEditOpen = () => setEdit(true);
  const handleEditClose = () => {
    setEdit(false);
    setDestination("");
    setDestinationId("");
    setRecording(false);
    setDescription("");
    setIvrAuthentication("");
    setRedirectGroup("");
    setStatus("");
    setVoip([]);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case "destination":
        setDestination(value);
        break;
      case "description":
        setDescription(value);
        break;
      default:
        break;
    }
  };

  const handleEdit = (data) => {
    handleEditOpen();
    setRecording(data?.recording);
    setIvrAuthentication(data?.ivr_authendication);
    setDescription(data?.description);
    setDestination(data?.didnumber);
    setDestinationId(data?.destinationId);
    setStatus(data?.status);
    setRedirectGroup(data?.redirect_group_id);
    setVoip(data?.voip_spam ? data?.voip_spam.split(",") : []);
  };

  const handleOpen = (description) => {
    setSelectedDescription(description);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useMemo(() => {
    setRedirectGroupData(state.getUserRedirectGroups.RedirectGroup);
  }, [state.getUserRedirectGroups.RedirectGroup]);

  const handleUpdate = () => {
    const payload = {
      id: destinationId,
      recording: recording,
      description: description,
      ivr_options: ivrAuthentication,
      redirect_group_id: redirectGroup,
      did_status: status === "A" ? "A" : "D",
    };
    if (voipSpamEnabled) {
      payload.voip_spam = voip;
    }
    const data = JSON.stringify(payload);
    dispatch(updateRedirectDestination(data, setResponse, handleEditClose));
  };

  const handleMessage = useCallback((data) => {
    setAlertMessage(true);
  }, []); // Memoize event handler

  const handleAlertClose = () => {
    setAlertMessage(false);
  };

  useEffect(() => {
    dispatch(getRedirectDestination(radioValue, setLoader));
    dispatch(getUserRedirectGroups());
    dispatch({ type: GET_REDIRECT_DESTINATION_SUCCESS, payload: [] });
  }, [response, radioValue, setLoader]);

  // Handle row selection
  const handleRowSelection = (newSelection) => {
    setSelectedRows(newSelection);
    setShowBulkActions(newSelection.length > 0);
  };

  // --------------Columns Data Condition For Mobile View and Desktop View---------------------
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));

  // ------------All Columns Data------------------------------
  const allColumns = [
    {
      field: "edit",
      headerName: "Action",
      headerClassName: "redirect_custom-header",
      flex: 1,
      width: isXs ? 55 : 80,
      minWidth: 55,
      maxWidth: 80,
      headerAlign: "left",
      disableColumnMenu: true,
      sortable: true,
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)", fontWeight: "bold" }}
        >
          Action
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center">
            <Tooltip title="Edit">
              <IconButton
                onClick={() => handleEdit(params.row)}
                style={{
                  fontSize: "22px",
                }}
              >
                <Edit
                  index={params.row.id}
                  style={{
                    cursor: "pointer",
                    color: "#42765f",
                    fontSize: "calc(0.8rem + 0.8vw)",
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "didnumber",
      headerName: "Destination",
      headerClassName: "redirect_custom-header",
      headerAlign: "left",
      flex: 1,
      width: isXs ? 100 : "100%",
      minWidth: 100,
      maxWidth: "100%",
      align: "left",
      disableColumnMenu: true,
      sortable: true,
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)", fontWeight: "bold" }}
        >
          Destination
        </Typography>
      ),
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontSize: "calc(0.6rem + 0.3vw)" }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "redirect_group_name",
      headerName: "Campaign Name",
      headerClassName: "custom-header",
      flex: 1,
      width: isXs ? 80 : "100%",
      minWidth: 80,
      maxWidth: "100%",
      headerAlign: "left",
      disableColumnMenu: true,
      sortable: true,
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)", fontWeight: "bold" }}
        >
          Campaign Name
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <span
            style={{
              fontSize: "calc(0.6rem + 0.3vw)",
            }}
          >
            {params.row.redirect_group_name}
          </span>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      width: isXs ? 58 : "100%",
      minWidth: 58,
      maxWidth: "100%",
      headerAlign: "left",
      align: "left",
      disableColumnMenu: true,
      sortable: true,
      headerClassName: "custom-header",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)", fontWeight: "bold" }}
        >
          Status
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <>
            {params.row.status === "A" ? (
              <>
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    color: "green",
                    fontSize: "calc(0.5rem + 0.3vw)",
                  }}
                >
                  Active
                </div>
              </>
            ) : (
              <>
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    color: "red",
                    fontSize: "calc(0.5rem + 0.3vw)",
                  }}
                >
                  Deactive
                </div>
              </>
            )}
          </>
        );
      },
    },
    {
      field: "ivr_authendication",
      headerName: "IVR Auth",
      headerClassName: "custom-header",
      flex: 1,
      minWidth: 70,
      maxWidth: "100%",
      disableColumnMenu: true,
      sortable: true,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => {
        const val = params.row.ivr_authendication;
        return (
          <>
            <span style={{ textTransform: "capitalize" }}>{val}</span>
          </>
        );
      },
    },
    {
      field: "voip_spam",
      headerName: "Voip Spam",
      headerClassName: "custom-header",
      width: isXs ? 100 : 120,
      minWidth: 100,
      maxWidth: 120,
      headerAlign: "start",
      align: "start",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Voip Spam
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <span
            style={{
              textTransform: "capitalize",
              fontSize: "calc(0.6rem + 0.2vw)",
            }}
          >
            {params.row.voip_spam}
          </span>
        );
      },
    },
    {
      field: "recording",
      headerName: "Recording",
      headerClassName: "custom-header",
      flex: 1,
      width: isXs ? 55 : "100%",
      minWidth: 55,
      maxWidth: "100%",
      disableColumnMenu: true,
      sortable: true,
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)", fontWeight: "bold" }}
        >
          Recording
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center">
            {params.row.recording === false ? (
              <>
                <div
                  style={{
                    color: "red",
                    textTransform: "capitalize",
                  }}
                >
                  No
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    color: "green",
                    textTransform: "capitalize",
                  }}
                >
                  Yes
                </div>
              </>
            )}
          </div>
        );
      },
    },

    {
      field: "created_at",
      headerName: "Created At",
      headerClassName: "custom-header",

      minWidth: 120,
      flex: 1,

      headerAlign: "start",
      align: "start",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Created At
        </Typography>
      ),

      renderCell: (params) => {
        // Parse the date string and format it
        const dateTimeString = params.value; // e.g., "2024:10:11 12:41:56"
        const formattedString = dateTimeString
          ?.replace(/:/g, "-") // Change to "2024-10-11 12-41-56"
          ?.replace(/-(\d{2})-(\d{2})$/, ":$1:$2"); // Change to "2024-10-11 12:41:56"
        const formattedDate = dayjs(formattedString).format("DD/MM/YYYY");
        const formattedTime = dayjs(formattedString).format("HH:mm:ss");

        return (
          <span>
            <span style={{ color: "green", fontSize: "calc(0.6rem + 0.2vw)" }}>
              {formattedDate}
            </span>
            <span style={{ color: "blue", fontSize: "calc(0.6rem + 0.2vw)" }}>
              {" "}
              {formattedTime}
            </span>
            {/* <p
                  style={{ color: "green", fontSize: "13px" }}
                >
                  
                </p>{" "}
                <p
                  style={{ color: "blue", fontSize: "13px" }}
                >
                  
                </p> */}
          </span>
        );
      },
    },

    {
      field: "description",
      headerName: "Description",
      headerClassName: "custom-header",
      flex: 1,
      minWidth: 92,
      maxWidth: "100%",
      disableColumnMenu: true,
      sortable: true,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: "pointer",
            maxWidth: "100%",
          }}
          onClick={() => handleOpen(params.value)}
          title="Click to expand"
        >
          {params.value && params.value.length > 50
            ? params.value.substring(0, 50) + "..."
            : params.value}
        </div>
      ),
    },
  ];

  // --------------Only Mobile View Columns Data---------------------
  const mobileColumns = allColumns.filter((col) =>
    [
      "edit",
      "didnumber",
      "redirect_group_name",
      "status",
      "recording",
    ].includes(col.field),
  );

  // --------------Table Options---------------------
  const columns = isMobile ? mobileColumns : allColumns;

  const rows = [];
  state?.getRedirectDestination?.RedirectDestination &&
    state?.getRedirectDestination?.RedirectDestination?.data?.forEach(
      (item, index) => {
        return rows.push({
          id: index + 1,
          carrier_name: item?.carrier_name,
          didnumber: item?.didnumber,
          description: item?.description,
          recording: item?.recording,
          redirect_group_id: item?.redirect_group_id,
          status: item?.did_status,
          user_id: item?.user_id,
          username: item?.username,
          destinationId: item?.id,
          ivr_authendication: item?.ivr_options,
          group_name: item.group_name,
          redirect_group_name: item.redirect_group_name,
          created_at: item?.created_at,
          voip_spam: item?.voip_spam,
        });
      },
    );

  const filteredRows = rows.filter((row) =>
    row.didnumber?.toLowerCase().includes(searchDestination.toLowerCase()),
  );

  const selectedCallerDataSet = new Set(); // Using Set to avoid duplicates

  selectedRows.forEach((id) => {
    const selectedRow = filteredRows.find((row) => row.id === id);
    if (selectedRow) {
      selectedCallerDataSet.add(selectedRow.destinationId); // Add only destinationId
    }
  });

  const selectedCallerData = Array.from(selectedCallerDataSet); // Convert to comma-separated string

  // Handle Active
  const handleSelectAll = () => {
    setAlertMessage(true);
    setName("Active");
  };

  // Handle Deactive
  const handleDeleteSelected = () => {
    setAlertMessage(true);
    setName("Deactive");
  };

  const handleUpdateStatus = () => {
    if (name === "Active") {
      const payload = JSON.stringify({
        ids: selectedCallerData,
        did_status: "A",
      });
      dispatch(
        updateRedirectDestinationStaus(
          payload,
          setResponse,
          setShowBulkActions,
        ),
      );
    } else {
      const payload = JSON.stringify({
        ids: selectedCallerData,
        did_status: "D",
      });
      dispatch(
        updateRedirectDestinationStaus(
          payload,
          setResponse,
          setShowBulkActions,
        ),
      );
    }
    setAlertMessage(false);
  };

  return (
    <>
      <div className={`App ${userThem} `}>
        <div className="contant_box">
          <div className="main">
            <section className="sidebar-sec">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="">
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div className="tab_cntnt_box">
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "12px",
                                width: "100%",
                              }}
                            >
                              {/* Title */}
                              <PageTitle title="Destination" />

                              {/* Search */}
                              <Box
                                sx={{
                                  width: { xs: "100%", sm: "300px" },
                                }}
                              >
                                <TextField
                                  size="small"
                                  fullWidth
                                  variant="outlined"
                                  placeholder="Search destination numbers..."
                                  value={searchDestination}
                                  onChange={(e) =>
                                    setSearchDestination(e.target.value)
                                  }
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                      </InputAdornment>
                                    ),
                                    endAdornment: searchDestination && (
                                      <InputAdornment position="end">
                                        <IconButton
                                          edge="end"
                                          size="small"
                                          onClick={() =>
                                            setSearchDestination("")
                                          }
                                        >
                                          <ClearIcon fontSize="small" />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: { xs: 36, sm: 40 },
                                      fontSize: { xs: 13, sm: 14 },
                                    },
                                  }}
                                />
                              </Box>
                            </div>

                            <Dialog
                              open={open}
                              onClose={handleClose}
                              fullWidth
                              maxWidth="sm"
                            >
                              <DialogTitle>
                                Full Description
                                <IconButton
                                  aria-label="close"
                                  onClick={handleClose}
                                  sx={{
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                  }}
                                >
                                  <CloseIcon />
                                </IconButton>
                              </DialogTitle>
                              <DialogContent>
                                <p
                                  style={{
                                    wordBreak: "break-word",
                                    whiteSpace: "pre-wrap",
                                  }}
                                >
                                  {selectedDescription}
                                </p>
                              </DialogContent>
                            </Dialog>

                            <div className="d-flex flex-wrap align-items-center justify-content-end justify-content-md-start mb-2 mt-sm-2">
                              <div>
                                <FormControl>
                                  <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={radioValue}
                                    onChange={(e) => {
                                      setRadioValue(e.target.value);
                                      setLoader(true);
                                    }}
                                  >
                                    <FormControlLabel
                                      value=""
                                      control={<Radio />}
                                      label={`All(${
                                        radioValue === "A" || radioValue === "D"
                                          ? 0
                                          : rows.length
                                      })`}
                                    />
                                    <FormControlLabel
                                      value="A"
                                      control={<Radio />}
                                      label={`Active(${
                                        radioValue === "" || radioValue === "D"
                                          ? 0
                                          : rows.length
                                      })`}
                                    />
                                    <FormControlLabel
                                      value="D"
                                      control={<Radio />}
                                      label={`Deactivated(${
                                        radioValue === "" || radioValue === "A"
                                          ? 0
                                          : rows.length
                                      })`}
                                    />
                                  </RadioGroup>
                                </FormControl>

                                {/* Bulk Actions */}
                              </div>
                              <div className="m-0">
                                {showBulkActions && (
                                  <Box sx={{ m: 0, display: "flex", gap: 1 }}>
                                    <IconButton
                                      className="all_button_clr"
                                      onClick={handleSelectAll}
                                      sx={{
                                        fontSize: "15px",
                                        borderRadius: "5px",
                                        border: "none",
                                        color: "#fff",
                                        px: 4,
                                        textTransform: "capitalize",
                                        height: "35px",
                                        width: "90px",
                                        minWidth: "90px",
                                        flexShrink: 0,
                                        display: "inline-flex",
                                        justifyContent: "space-evenly",
                                        alignItems: "center",
                                      }}
                                    >
                                      Active
                                    </IconButton>

                                    <IconButton
                                      className="all_button_clr"
                                      onClick={handleDeleteSelected}
                                      sx={{
                                        fontSize: "15px",
                                        borderRadius: "5px",
                                        border: "none",
                                        backgroundColor: "#f5751d!important",
                                        color: "#fff",
                                        px: 4,
                                        textTransform: "capitalize",
                                        height: "35px",
                                        width: "90px",
                                        minWidth: "90px",
                                        flexShrink: 0,
                                        display: "inline-flex",
                                        justifyContent: "space-evenly",
                                        alignItems: "center",
                                      }}
                                    >
                                      Deactive
                                    </IconButton>
                                    {/* <Button
                                        variant="contained"
                                        color="error"
                                        onClick={handleDeleteSelected}
                                        startIcon={<Delete />}
                                        size="small"
                                      >
                                        Deactive 
                                      </Button> */}
                                  </Box>
                                )}
                              </div>
                            </div>

                            {/* delete modal */}

                            <Dialog
                              open={alertMessage}
                              onClose={handleAlertClose}
                              aria-labelledby="alert-dialog-title"
                              aria-describedby="alert-dialog-description"
                              sx={{ textAlign: "center" }}
                              //className="bg_imagess"
                            >
                              <DialogTitle
                                id="alert-dialog-title"
                                sx={{ color: "#133325", fontWeight: "600" }}
                              >
                                {"Status Confirmation"}
                              </DialogTitle>
                              <DialogContent>
                                <DialogContentText
                                  id="alert-dialog-description"
                                  sx={{ paddingBottom: "0px !important" }}
                                >
                                  Are you sure you want to {name} ?
                                </DialogContentText>
                              </DialogContent>
                              <DialogActions
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  paddingBottom: "20px",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  sx={{
                                    fontSize: "16px !impotant",
                                    background:
                                      "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                                    marginTop: "10px",
                                    marginLeft: "0px !important",
                                    padding: "10px 20px !important",
                                    textTransform: "capitalize !important",
                                  }}
                                  className="all_button_clr"
                                  color="info"
                                  onClick={handleAlertClose}
                                  autoFocus
                                >
                                  Cancel
                                </Button>
                                <Button
                                  variant="contained"
                                  sx={{
                                    fontSize: "16px !impotant",
                                    marginTop: "10px",
                                    padding: "10px 20px !important",
                                    textTransform: "capitalize !important",
                                    marginLeft: "0px !important",
                                    marginRight: "0px !important",
                                  }}
                                  className="all_button_clr"
                                  color="error"
                                  onClick={handleUpdateStatus}
                                  //startIcon={<DeleteIcon />}
                                >
                                  Update
                                </Button>
                              </DialogActions>
                            </Dialog>

                            {loader ? (
                              <>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    width: "90%",
                                    marginTop: "9rem !important",
                                  }}
                                >
                                  <CircularProgress />
                                </Box>
                              </>
                            ) : (
                              <>
                                <ThemeProvider theme={theme}>
                                  <div
                                    style={{ width: "100%", overflowX: "auto" }}
                                  >
                                    <StyledDataGrid
                                      rows={filteredRows}
                                      columns={columns}
                                      components={{ Toolbar: GridToolbar }}
                                      slots={{
                                        toolbar: CustomToolbar,
                                      }}
                                      autoHeight
                                      disableColumnResize={false}
                                      density="compact"
                                      hideFooterPagination={
                                        window.innerWidth < 600
                                      }
                                      checkboxSelection
                                      disableRowSelectionOnClick
                                      rowSelectionModel={selectedRows}
                                      onRowSelectionModelChange={
                                        handleRowSelection
                                      }
                                      sx={{
                                        "& .MuiDataGrid-cell": {
                                          fontSize: {
                                            xs: "12px",
                                            sm: "14px",
                                            md: "14px",
                                          },
                                          wordBreak: "break-word !important",
                                          whiteSpace: "break-spaces !important",
                                        },
                                      }}
                                    />
                                  </div>
                                </ThemeProvider>
                              </>
                            )}

                            <Dialog
                              className="custom_dailog_box_user"
                              open={edit}
                              onClose={handleEditClose}
                              sx={{ textAlign: "center" }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  paddingTop: "10px",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography
                                  className="modal_heading"
                                  sx={{
                                    color: "#133325",
                                    fontWeight: "600",
                                    width: "500px",
                                  }}
                                >
                                  Update Destination
                                </Typography>
                                <IconButton
                                  className="close_icon"
                                  onClick={handleEditClose}
                                  sx={{ float: "inline-end" }}
                                >
                                  <Close />
                                </IconButton>
                              </Box>
                              <DialogContent>
                                <form>
                                  <form style={{ textAlign: "center" }}>
                                    <TextField
                                      style={{
                                        width: "100%",
                                        margin: " 5px 0 5px 0",
                                      }}
                                      type="text"
                                      label="Destination"
                                      variant="outlined"
                                      name="destination"
                                      value={destination}
                                      onChange={handleChange}
                                      padding={"0px 0 !important"}
                                      disabled
                                    />
                                    <br />
                                    <FormControl
                                      fullWidth
                                      style={{ width: "100%", margin: "7px 0" }}
                                    >
                                      <InputLabel id="demo-simple-select-label">
                                        IVR Authentication
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="IVR Authentication"
                                        helperText="Select the language."
                                        style={{ textAlign: "left" }}
                                        value={ivrAuthentication}
                                        onChange={(e) => {
                                          setIvrAuthentication(e.target.value);
                                        }}
                                        required
                                      >
                                        <MenuItem value={"no"}>No</MenuItem>
                                        <MenuItem value={"random"}>
                                          Random
                                        </MenuItem>
                                        <MenuItem value={"0"}>0</MenuItem>
                                        <MenuItem value={"1"}>1</MenuItem>
                                        <MenuItem value={"2"}>2</MenuItem>
                                        <MenuItem value={"3"}>3</MenuItem>
                                        <MenuItem value={"4"}>4</MenuItem>
                                        <MenuItem value={"5"}>5</MenuItem>
                                        <MenuItem value={"6"}>6</MenuItem>
                                        <MenuItem value={"7"}>7</MenuItem>
                                        <MenuItem value={"8"}>8</MenuItem>
                                        <MenuItem value={"9"}>9</MenuItem>
                                      </Select>
                                    </FormControl>

                                    <FormControl
                                      fullWidth
                                      style={{
                                        width: "100%",
                                        margin: "7px 0",
                                      }}
                                    >
                                      <InputLabel id="destination-status-label">
                                        Status
                                      </InputLabel>
                                      <Select
                                        labelId="destination-status-label"
                                        id="destination-status-select"
                                        label="Status"
                                        helperText="Select the language."
                                        style={{ textAlign: "left" }}
                                        value={status}
                                        onChange={(e) =>
                                          setStatus(e.target.value)
                                        }
                                        required
                                      >
                                        <MenuItem value={"A"}>Active</MenuItem>
                                        <MenuItem value={"D"}>
                                          Deactive
                                        </MenuItem>
                                      </Select>
                                    </FormControl>

                                    {voipSpamEnabled ? (
                                      <FormControl
                                        fullWidth
                                        style={{
                                          width: "100%",
                                        }}
                                      >
                                        <InputLabel id="voip-spam-checkbox-label">
                                          VOIP Spam
                                        </InputLabel>
                                        <Select
                                          labelId="voip-spam-checkbox-label"
                                          id="voip-spam-select"
                                          label="VOIP Spam"
                                          multiple
                                          helperText="Select the language."
                                          style={{ textAlign: "left" }}
                                          value={voip}
                                          onChange={(e) => {
                                            setVoip(e.target.value);
                                          }}
                                          renderValue={(selected) =>
                                            selected.join(", ")
                                          }
                                          required
                                        >
                                          {options.map((name) => (
                                            <MenuItem key={name} value={name}>
                                              <Checkbox
                                                checked={voip.indexOf(name) > -1}
                                              />
                                              <ListItemText primary={name} />
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    ) : voip.length > 0 ? (
                                      // Read-only display for users who don't
                                      // have the voip_spam capability but whose
                                      // DID still has values configured. Without
                                      // this, the block was applied silently —
                                      // user couldn't see why some calls were
                                      // being filtered.
                                      <Box
                                        sx={{
                                          width: "100%",
                                          p: 1,
                                          border: "1px solid #e5e7eb",
                                          borderRadius: 1,
                                          bgcolor: "#f8fafc",
                                        }}
                                      >
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: "#64748b",
                                            display: "block",
                                            mb: 0.5,
                                          }}
                                        >
                                          VOIP Spam (managed by admin)
                                        </Typography>
                                        <Stack direction="row" spacing={0.5}>
                                          {voip.map((v) => (
                                            <Chip
                                              key={v}
                                              size="small"
                                              label={v}
                                              variant="outlined"
                                            />
                                          ))}
                                        </Stack>
                                      </Box>
                                    ) : null}

                                    <FormControl
                                      style={{
                                        width: "100%",
                                        margin: " 5px 0 5px 0",
                                      }}
                                    >
                                      <InputLabel id="demo-multiple-checkbox-label">
                                        Ring groups
                                      </InputLabel>
                                      <Select
                                        style={{ textAlign: "left" }}
                                        labelId="demo-multiple-checkbox-label"
                                        label="Ring groups"
                                        id="demo-multiple-checkbox"
                                        fullWidth
                                        value={redirectGroup}
                                        onChange={(e) =>
                                          setRedirectGroup(e.target.value)
                                        }
                                        input={
                                          <OutlinedInput label="Ring groups" />
                                        }
                                        MenuProps={MenuProps}
                                      >
                                        {redirectGroupData &&
                                          redirectGroupData?.map((name) => (
                                            <MenuItem
                                              key={name}
                                              value={name.id}
                                            >
                                              {name.group_name}
                                            </MenuItem>
                                          ))}
                                      </Select>
                                    </FormControl>

                                    <FormControl
                                      fullWidth
                                      style={{ width: "100%", margin: "7px 0" }}
                                    >
                                      <InputLabel id="destination-recording-label">
                                        Recording
                                      </InputLabel>
                                      <Select
                                        labelId="destination-recording-label"
                                        id="destination-recording-select"
                                        label="Recording"
                                        helperText="Select the language."
                                        style={{ textAlign: "left" }}
                                        value={recording}
                                        onChange={(e) => {
                                          setRecording(e.target.value);
                                        }}
                                        required
                                      >
                                        <MenuItem value={true}>Yes</MenuItem>
                                        <MenuItem value={false}>No</MenuItem>
                                      </Select>
                                    </FormControl>
                                    <br />
                                    <TextField
                                      style={{
                                        width: "100%",
                                        margin: " 5px 0 5px 0",
                                      }}
                                      type="text"
                                      label="Description"
                                      variant="outlined"
                                      name="description"
                                      value={description}
                                      onChange={handleChange}
                                      padding={"0px 0 !important"}
                                    />
                                  </form>
                                </form>
                              </DialogContent>
                              <DialogActions
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  paddingBottom: "20px",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  sx={{
                                    fontSize: "16px !impotant",
                                    background:
                                      "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                                    marginTop: "0px",
                                    marginLeft: "0px !important",
                                    padding: "10px 20px !important",
                                    textTransform: "capitalize !important",
                                  }}
                                  className="all_button_clr"
                                  color="info"
                                  onClick={handleEditClose}
                                  autoFocus
                                >
                                  Cancel
                                </Button>
                                <Button
                                  className="all_button_clr"
                                  sx={{
                                    fontSize: "16px !impotant",
                                    marginTop: "0px",
                                    marginLeft: "0px !important",
                                    padding: "10px 20px !important",
                                    textTransform: "capitalize !important",
                                  }}
                                  variant="contained"
                                  color="primary"
                                  onClick={handleUpdate}
                                >
                                  Update
                                </Button>
                              </DialogActions>
                            </Dialog>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default Destination;
